import React, {useEffect} from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';

import { useSelector, useDispatch } from 'react-redux';
import { showLogin } from '../../store/slices/configSlice';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 180,
  bgcolor: 'background.paper',
  border: '2px solid #4f4f4f',
  boxShadow: 24,
  textAlign: 'center',
  // border: 0,
  p: 4,
};


const ModalWaiting = () => {
    const {openWaiting} = useSelector( state => state.configuration);
    const dispatch = useDispatch();
    
    //TRANSLATION
    const [t, i18n] = useTranslation("global");
    
    // useEffect(()=>{
    //     setTimeout(()=>{
    //         dispatch(showWaiting(false));
    //     }, 2000)
    // }, []);
    
    return (
      <div>
        <Modal 
          open={openWaiting}
        >
          <Box sx={style}>
            <CircularProgress disableShrink />
            <Typography id="modal-modal-title" variant="h6" component="h2" style={{fontSize:12}}>
                <br />
                {t("util.WaitingMessage")}
            </Typography>
          </Box>
        </Modal>
      </div>
    );
};

export default ModalWaiting;